import React, { useContext } from "react";
import "./Portfolio.css";
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css";
import tomiProject from "../../img/tomi.png";
import nabanaProject from "../../img/Nabana.png";
import legionProject from "../../img/Legion.png";
import flashwallet from "../../img/flashwallet.png";
import taxiBooking from "../../img/taxiBooking.png";
import wnbProject from "../../img/wnb.png";
import dehrti from "../../img/dehrti.png";
import urgentMerrage from "../../img/urgentMerrage.png";
import grocery from "../../img/grocery.png";

import { themeContext } from "../../Context";
const Portfolio = () => {
  const theme = useContext(themeContext);
  const darkMode = theme.state.darkMode;
  const slidesPerView = window.innerWidth >= 768 ? 3 : 1;

  return (
    <div className="portfolio" id="portfolio">
      {/* heading */}
      <span style={{color: darkMode?'white': ''}}>Recent Projects</span>
      <span>Portfolio</span>

      {/* slider */}
      <Swiper
        spaceBetween={window.innerWidth >= 768 ? 100:80}
        slidesPerView={slidesPerView}
        grabCursor={true}
        marginHorizontal={100}
        className="portfolio-slider"
      >
    
        <SwiperSlide onClick={() => window.open('https://play.google.com/store/apps/details?id=com.tomiapp.production&pcampaignid=web_share', '_blank')}>
          <img src={tomiProject} alt="" />
        </SwiperSlide>
        <SwiperSlide onClick={() => window.open('https://play.google.com/store/apps/details?id=com.dhartipak', '_blank')}>
          <img src={dehrti} alt="" />
        </SwiperSlide>

        <SwiperSlide onClick={() => window.open('https://github.com/adnansudozai/Nabana', '_blank')}>
          <img src={nabanaProject} alt="" />
        </SwiperSlide>
        <SwiperSlide onClick={() => window.open('https://play.google.com/store/apps/details?id=com.legion.production&pcampaignid=web_share', '_blank')}>
          <img src={legionProject} alt="" />
        </SwiperSlide>

        <SwiperSlide onClick={() => window.open('https://flash-wallet.com/', '_blank')}>
          <img src={flashwallet} alt="" />
        </SwiperSlide>

        <SwiperSlide onClick={() => window.open('https://play.google.com/store/apps/details?id=com.urgentmarriage', '_blank')}>
          <img src={urgentMerrage} alt="" />
        </SwiperSlide>
        <SwiperSlide onClick={() => window.open('https://github.com/adnansudozai/Taxibookingclient', '_blank')}>
          <img src={taxiBooking} alt="" />
        </SwiperSlide>
     
        <SwiperSlide onClick={() => window.open('https://github.com/malikhamza0546/WNB-APP', '_blank')}>
          <img src={wnbProject}  alt="" />
        </SwiperSlide>

        <SwiperSlide onClick={() => window.open('https://github.com/muqeet98/Groceryapp', '_blank')}>
          <img src={grocery}  alt="" />
        </SwiperSlide>
     
     
       
      </Swiper>
    </div>
  );
};

export default Portfolio;
